export default __webpack_public_path__ + "static/media/graphic-12.0ac601a7.png";